import { get } from '@bigyouth/base'
import axios from 'axios'
import { get as getPipe } from '../utils/sigpipe'

import { ACTIONS as MODAL_ACTIONS } from './modal'

/**
 * Can be placed on an element to open a modal when the element is triggered by mouse or keyboard.
 *
 * Props:
 * target(string, required): Query string for the targetted modal
 */
export default {
  name: 'modal-control',

  events: [
    {
      on: 'click',
      handle: 'openModal',
    },
  ],

  openModal () {
    if (!this.pipe) {
      try {
        this.modal = get(this.props.target)

        if (this.props.dynamic) {
          this.loadDynamicModal()
        } else {
          this.pipe = getPipe(this.modal.getAttribute('data-pipe-id'))
        }
      } catch (e) {
        console.error(
          `[MODAL-CONTROL] Are you sure target ${this.props.target} exists ?`,
        )
      }
    }

    if (this.pipe) {
      if (this.props.dynamic) {
        this.loadDynamicModal()
      } else {
        this.pipe.write({ action: MODAL_ACTIONS.OPEN, emitterEl: this.el })
      }
    }
  },

  loadDynamicModal () {
    const url = config.locale === 'fr' ? `/ajax/modal/${this.props.type}/${this.el.dataset.id}` : `/en/ajax/modal/${this.props.type}/${this.el.dataset.id}`
    axios.get(url)
      .then((response) => {
        if (response.status === 200) {
          const container = document.querySelector(`#modal-${this.props.type} [js-modal-content]`)

          container.innerHTML = response.data

          const overlays = container.querySelectorAll('[js-video-player-overlay]')
          const videos = container.querySelectorAll('[js-video-player-video]')

          if (overlays.length && videos.length) {
            overlays.forEach((overlay, index) => {
              const video = videos[index]

              if (video) {
                overlay.addEventListener('click', () => {
                  overlay.classList.add('is-hidden')
                  video.play()
                }, { once: true })
              }
            })
          }

          this.pipe = getPipe(this.modal.getAttribute('data-pipe-id'))

          this.pipe.write({ action: MODAL_ACTIONS.OPEN, emitterEl: this.el })
        } else {
          console.log('error')
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
  },
}
